import { FinancialOverviewKeyEventKey } from '../../types';

export const getFinancialOverviewEventDestination = (type: FinancialOverviewKeyEventKey, tickerSymbol?: string) => {
    if (type === 'recessions') {
        return { href: '/search/events', label: 'View Economic Events' };
    }

    const symbol = tickerSymbol?.trim().toUpperCase();

    if (!symbol) {
        return undefined;
    }

    const tab = type === 'news' ? 'news' : 'dividends';

    return {
        href: `/search/companies/${encodeURIComponent(symbol)}/${tab}`,
        label: type === 'news' ? 'View Recent News' : 'View Dividends',
    };
};
